import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login/Auth.vue'),
  },
  
  {
    path: '/',
    name: 'user',
    component: () => import('../views/user/LayoutView.vue'),
    children: [
      {
        path: 'main',
        alias: '',
        name: 'userDashboard',
        component: () => import('../views/user/DashboardView.vue'),
      },
      {
        path: 'announce/(list)*',
        name: 'announceList',
        component: () => import('../views/user/AnnounceList.vue'),
      },
      {
        path: 'announce/view/:id',
        name: 'announceView',
        component: () => import('../views/user/AnnounceView.vue'),
      },

    ]
  },


  {
    path: '/tablo',
    name: 'tablo',
    component: () => {
      if(window.prompt('Введите пароль!') == 'qamtu') {
        return import('../views/user/TabloView.vue')
      } else {
        return '';
      }
    },
  },
]

const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if(to.name == 'tablo') {
    next();
  } else {
    if(to.name != 'login' && !store.getters.getAccessToken) {
      store.dispatch('logout');
    } else if(to.path == '/' || (to.name == 'login' && store.getters.getAccessToken)) {
      next('/main');
    } else {
      next();
    }
  }
});

export default router
